/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { TipoPraticaCloneForm } from '../model/tipo-pratica-clone-form';
// @ts-ignore
import { TipoPraticaCloneResponseDTO } from '../model/tipo-pratica-clone-response-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaCloneServiceInterface,
    CloneTipoPraticaRequestParams
} from './tipo-pratica-clone.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaCloneService extends BaseService implements TipoPraticaCloneServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Clona un TipoPratica esistente (SUPERADMIN)
     * Crea un nuovo TipoPratica clonando selettivamente il root e i satelliti del bando origine indicato dal path. Il payload richiede &#x60;codice&#x60; e &#x60;descrizione&#x60; obbligatori; &#x60;comune_id_destinazione&#x60; opzionale (null&#x3D;same-comune, UUID&#x3D;cross-comune); &#x60;include&#x60; opzionale con 7 toggle livello-1 (default: tutti true tranne &#x60;comunicazioni&#x3D;false&#x60;). Lo stato del nuovo TipoPratica e\&#39; sempre IN_ATTESA (anche se origine era PUBBLICATO). Gli operatori non sono mai clonati. Cross-comune azzera URL, scalari finanziari e contributi assegnazione. Vedi &#x60;openspec/changes/add-tipo-pratica-clone/&#x60; per le decisioni complete.  Risposte: - 201: &#x60;TipoPraticaCloneResponseDTO&#x60; con &#x60;tipo_pratica&#x60; (stesso shape di GET .../{id}) e &#x60;clone_summary&#x60;. - 400: payload invalido (codice/descrizione blank, comune_id_destinazione UUID inesistente). - 403: caller non SUPERADMIN. - 404: TipoPratica origine non trovato. - 409: codice gia\&#39; usato nel comune destinazione. - 422: &#x60;include.template_form_cittadino&#x3D;true&#x60; con &#x60;include.attributi_e_valori&#x3D;false&#x60;.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/clone
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public cloneTipoPratica(requestParameters: CloneTipoPraticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaCloneResponseDTO>;
    public cloneTipoPratica(requestParameters: CloneTipoPraticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaCloneResponseDTO>>;
    public cloneTipoPratica(requestParameters: CloneTipoPraticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaCloneResponseDTO>>;
    public cloneTipoPratica(requestParameters: CloneTipoPraticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cloneTipoPratica.');
        }
        const tipoPraticaCloneForm = requestParameters?.tipoPraticaCloneForm;
        if (tipoPraticaCloneForm === null || tipoPraticaCloneForm === undefined) {
            throw new Error('Required parameter tipoPraticaCloneForm was null or undefined when calling cloneTipoPratica.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/clone`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaCloneResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaCloneForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
